export default __webpack_public_path__ + "static/media/portrait_cityscape.b0f30836.png";